import { createContext, useContext, useState, useCallback } from "react";

const DialogContext = createContext();

export const DialogProvider = ({ children }) => {
  const [dialog, setDialog] = useState({
    open: false,
    title: "",
    message: "",
    buttonLabel: "",
    secondaryButtonLabel: "",
    showIcon: true,
    iconType: "",
    onModalSubmit: null,
    centered: false,
  });

  const showDialog = useCallback(
    (
      title,
      message,
      buttonLabel,
      showIcon = true,
      secondaryButtonLabel,
      iconType,
      onModalSubmit,
      centered
    ) => {
      setDialog({
        open: true,
        title,
        message,
        buttonLabel,
        secondaryButtonLabel,
        showIcon,
        iconType,
        onModalSubmit,
        centered,
      });
    },
    []
  );

  const hideDialog = useCallback(() => {
    setDialog((prev) => ({ ...prev, open: false }));
  }, []);

  return (
    <DialogContext.Provider value={{ dialog, showDialog, hideDialog }}>
      {children}
    </DialogContext.Provider>
  );
};

export const useDialog = () => {
  const ctx = useContext(DialogContext);
  if (!ctx) throw new Error("useDialog must be used inside DialogProvider");
  return ctx;
};
